import { useEffect } from 'react';

interface IUseSyncChecklistOpenParams {
    isOpen: boolean;
    onOpenChange?: (isOpen: boolean) => void;
}

export const useSyncChecklistOpen = ({
    isOpen,
    onOpenChange,
}: IUseSyncChecklistOpenParams) => {
    useEffect(() => {
        onOpenChange?.(isOpen);

        return () => {
            onOpenChange?.(false);
        };
    }, [isOpen, onOpenChange]);
};
